import styled from 'styled-components';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';


export const Container = styled.div`
  
`;

export const PopperIcon = styled(Popper)`
  z-index: 1;
  width: 100%;
  max-width: 330px;
`;

export const HistoryList = styled(Paper)`
  height: 100%;
`;

export const ListContent = styled(ListItem)`
  /* background: ${props => props.animate};
    transition: all 3s; */
    min-height: 80px;
    padding-bottom: 20px;
  &:hover {
    background: ${props => props.hover};
  }
`;

export const Scroll = styled(PerfectScrollbar)`
  max-height: 290px;
`;

export const MessageContent = styled.span`
  font-size: 14px;
`;

export const MessageDate = styled(Typography)`
  padding: 12px;
  font-size: 12px;
  color: #333333;

`;

export const MessageEmpty = styled(Typography)`
  font-size: 18px;
  margin: 12px 0px 4px;
`;

export const MessageTitle = styled.div`
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  align-items: center;
  min-width: 300px;

`;

export const HeaderTitle = styled(Typography)`
  height: 30px;
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShowMore = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px
`;

export const RedNot = styled.div`
   width: 6px; 
   height: 6px; 
   border-radius: 50%;
  background: red; 
  margin: 5px;
`;

